$(document).ready(function () {

	//update datos de modelo
	jQuery.each(jQuery('[data-role="selector_modelo"]'), function () {
		var $selector = $(this),
			api_route = $selector.data('action');

		$selector.change(function () {
			$('[data-role="calculador_dividendo"] input').val('').removeClass('valid-input');
			$('[data-role="calculador_dividendo"] select').removeClass('valid-input');
			$('[data-role="calculador_dividendo"]').removeClass('valid-control');
			$('#monto_dividendo').val('').attr('value', '');

			var modelo_id = $selector.val();

			if(modelo_id == ''){
				$('#modelo_id').attr('value', '');
				$('#valor_uf').attr('value', '');
				return;
			}

			$.ajax({
				url: api_route,
				type: 'POST',
				dataType: 'json',
				data: {
					modelo_id: modelo_id
				}
			}).done(function (response) {
				console.log(response);
				console.log(response.valor_uf);
				// $('#proyecto_id').val(response.proyecto_id);
				$('#modelo_id').val(modelo_id);
				$('#valor_uf').val(response.valor_uf);
				$('#valor_pesos').val(response.valor_pesos);
			});
		});
	});

	jQuery.each(jQuery('[data-role="calculador_dividendo"]'), function () {
		var $calculador_parent = $(this),
			$selector_modelo = $('[data-role="selector_modelo"]'),
			$selector_calculo = $($calculador_parent.find('select')),
			$campo_calculo = $($calculador_parent.find('input'));


		$selector_calculo.change(function () {
			$campo_calculo.val('');
		});

		$campo_calculo.keyup(function (event) {
			event.preventDefault();
			var $this = $(this);
			if($selector_modelo.val() !== '' && $('#valor_uf').val() > 0){
				getDividendo($this);
			}
		})
	});

	$('#formulario_dividendo').submit(function(event){
		event.preventDefault();

		var form = this,
			 $form = $(form);
			 
		var api_route = $form.attr('action'),
		formData = new FormData(form),
		formulario = $form.serializeArray();

		$form.addClass('sending');

		$.ajax({
			url: api_route,
			type: 'POST',
			data: formData,
			dataType: "json",
			cache: false,
			contentType: false,
			processData: false
		}).done(function (response) {
			console.log(response);
			$form.removeClass('sending');
			$('[data-role="scripts-holder"]').html(response.script);
		});
	})
});




function getDividendo($this) {
	var api_route = $($this.parents('.form-control')).data('action'),
		active_value = $this.val(),
		active_type = $this.attr('name'),
		modelo_uf = $('#valor_uf').val(),
		modelo_pesos = $('#valor_pesos').val(),
		porcentaje_minimo = $('#porcentaje_minimo').val();

	$.ajax({
		url: api_route,
		type: 'GET',
		dataType: 'json',
		data: {
			monto: active_value,
			tipo_monto: active_type,
			modelo_uf: modelo_uf,
			modelo_pesos: modelo_pesos,
			porcentaje_minimo: porcentaje_minimo
		}
	}).done(function (response) {
		// console.log('get dividendo');
		// console.log(response);

		if (response.status == 'ok') {
			// console.log('ok');
			$($('#' + active_type).parents('.form-control')).find('input,select').removeClass('invalid-input').addClass('valid-input');
			$($('#' + active_type).parents('.form-control')).removeClass('invalid-control').addClass('valid-control');

			$('#monto_dividendo').val(response.monto_dividendo);
			$('#monto_dividendo').attr('data-validizr-validity', true).addClass('valid-input').removeClass('invalid-input');
			$($('#monto_dividendo').parents('.form-control')).removeClass('invalid-control').addClass('valid-control');

			$('[data-role="dividendo_alert"]').html('');

			$('[data-role="cotizador_submit"]').attr('disabled', false);


		} else {
			$($('#' + active_type).parents('.form-control')).find('input,select').addClass('invalid-input').removeClass('valid-input');
			$($('#' + active_type).parents('.form-control')).addClass('invalid-control').removeClass('valid-control');

			$('#monto_dividendo').val(response.monto_dividendo);
			$('#monto_dividendo').attr('data-validizr-validity', false).removeClass('valid-input').addClass('invalid-input');
			$($('#monto_dividendo').parents('.form-control')).addClass('invalid-control').removeClass('valid-control');

			$('[data-role="cotizador_submit"]').attr('disabled', true);

			if (response.status == 'too_high') {
				$('[data-role="dividendo_alert"]').html($('#monto_dividendo').data('message-toohigh'));
			} else {
				$('[data-role="dividendo_alert"]').html($('#monto_dividendo').data('message-toolow'));
			}
		}

	});
};